import {DocumentSystemType} from "../../../model2/doc/types"
import Document from "../../../model2/doc/document"

// The DOCUMENT branch of itemRouteUrl -- the string form of `Document.goTo`, so
// a page / whiteboard resource keeps its project route here too. Keep the two in
// step; `goTo` navigates and cannot hand back a URL for a new window.
export default function documentRouteUrl(document: Document): string {
    if (document.systemType === DocumentSystemType.PAGE)
        return '/p/' + document.projectId + '/page/' + document.id

    if (document.systemType === DocumentSystemType.WHITEBOARD_RESOURCE)
        return '/p/' + document.projectId + '/whiteboard/' + document.id

    return '/n/' + document.id
}
